<div [id]="id" class="w-full w-[350px] relative shadow-md rounded-2xl">
  <div
    class="relative rounded-2xl min-h-[60px] w-full bg-white flex items-center gap-4 p-4 ml-1 z-10"
  >
    <div class="relative w-6 h-6" [ngSwitch]="type">
      <m-icons
        name="info"
        class="text-mg-primary"
        *ngSwitchCase="'info'"
      ></m-icons>
      <m-icons
        name="checkmark-circle"
        class="text-mg-success"
        *ngSwitchCase="'success'"
      ></m-icons>
      <m-icons
        name="close-circle"
        class="text-mg-error"
        *ngSwitchCase="'error'"
      ></m-icons>
    </div>
    <p
      class="flex flex-1 w-full break-words footnote"
      [innerHTML]="toastRef.data.message"
    ></p>
    <div
      class="flex items-center justify-center cursor-pointer w-7 h-7"
      (click)="forceClose()"
      (keydown.space)="forceClose()"
    >
      <div class="relative w-6 h-6">
        <m-icons name="close" class="text-mg-neutral-light"></m-icons>
      </div>
    </div>
  </div>
  <div
    [id]="id"
    class="absolute top-0 rounded-2xl h-full w-full max-w-[398px] flex items-center justify-center z-0"
    [ngClass]="{
      'bg-mg-primary': type === 'info',
      'bg-mg-success': type === 'success',
      'bg-mg-error': type === 'error'
    }"
  ></div>
</div>
